import { Component } from 'react';
import Header from '../../../Header';
import MessageLink from '../../../MessageLink';
import Footer from '../../../Footer';
import Timeline from '../../../Timeline';
import imgHistoria from '../../../../assets/img/historia/img-historia.jpg';	
import Lgpd from '../../../Lgpd';
import ErrorBoundary from '../../../ErrorHandler/ErrorBoundary';
import InfoComponent from '../../InfoComponent';

class Historia extends Component {
	render() {
	  return (
		<div>
		  {/* HEADER */}{/* LOGIN */}
		  <ErrorBoundary><Header /></ErrorBoundary>
		  <main>

			<InfoComponent image={"Historia"} page={'Historia'}></InfoComponent>		

			{/* Content page */}
			<section className="_the-content">
			  <div className="container">
				<div className="row justify-content-center">
				  <div className="col-lg-10">					
					<div className="d-flex justify-content-between align-items-start flex-wrap">
					  <blockquote className=" order-2 order-lg-1 blockquoteCorrect">						
						<strong> Confira o livro produzido quando a Entidade completou 40 anos. </strong> Nele, é possível conferir os principais fatos de sua trajetória nas primeiras quatro décadas de existência.
					  </blockquote>
					  <img src={imgHistoria} alt="Descricao" className="order-1 order-lg-2" />
					</div>
					<hr />
				  </div>
				</div>
			  </div>
			</section>
			{/* Timeline */}
			  <ErrorBoundary>  
				<Timeline/>
			  </ErrorBoundary>  
		  </main>
		  {/* FOOTER */}
		 <ErrorBoundary> <Footer />  </ErrorBoundary>
		  <ErrorBoundary><MessageLink/></ErrorBoundary>
		  {/* LGPD */}
		  <ErrorBoundary><Lgpd /></ErrorBoundary>
		</div>
	  );
	}
  };

  export default Historia;